module.exports = __webpack_public_path__ + "static/media/1895-legacy.768f93b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/legacy/1895-legacy.png
// module id = 365
// module chunks = 0